<template>
  <section id="fideicomiso">
    <FideicomisoHeader class="header" :closeSidepanel="closeSidepanel" />
    <div class="container main">
      <div class="col-12 status">
        <StatusCardDisplayer
          :title="documentType.type"
          :cards="documentType.data"
          v-for="(documentType, i) in documentTypesNoPress"
          :key="i"
          class="status-card-displayer"
        />
        <StartupPressCard
          v-if="documentTypesPress"
          class="status-card-displayer"
          :documents="documentTypesPress.data"
        />
      </div>
    </div>
  </section>
</template>

<script>
import FideicomisoHeader from './FideicomisoHeader.vue';
import StatusCardDisplayer from './StatusCardDisplayer.vue';
import StartupPressCard from './StartupPressCard.vue';

export default {
  name: 'FideicomisoDetails',
  components: {
    FideicomisoHeader,
    StatusCardDisplayer,
    StartupPressCard,
  },
  props: {
    closeSidepanel: Function,
    fideicomisoData: Array,
  },
  computed: {
    selectedFondo() {
      return this.$store.state.selectedFondo;
    },
    documentTypes(){
      const dataByType = [];
      this.fideicomisoData.forEach(element => {
        const fondos = Array.isArray(element.fondos) ? element.fondos : Object.values(element.fondos);
        if(fondos.some(x => x === this.selectedFondo) || (!fondos.length && this.selectedFondo === 'GRIDX')) {
          let typeObject = dataByType.find(x => x.type === element.type);
          if(!typeObject){
            typeObject = {
              type: element.type,
              data: [],
            }
            dataByType.push(typeObject);
          }

          typeObject.data.push({ 
            ...element, 
            fecha: element.date, 
            title: element.name,
          });
        }

       
      });
      return dataByType;
    },
    documentTypesNoPress(){
      return this.documentTypes.filter(x => x.type != "Prensa");
    },
    documentTypesPress(){
      return this.documentTypes.find(x => x.type === "Prensa")
    }
  },
};
</script>

<style scoped lang="scss">
#fideicomiso {
  min-height: 100vh;
  background: #f9f6fc;
  padding-bottom: 50px;

  @media (min-width: 768px) {
    background: #fff;
  }

  .status-card-displayer {
    margin: 30px 0;
  }
}
</style>
